<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onMounted(async () => {
  // tenta restaurar sessão pelo cookie
  await auth.fetchMe()
})
</script>

<template>
  <RouterView />
</template>
